export class DownloadInformation {
  downloading: boolean = false;
}
